import { RateLimited } from '@/lib/errors';
import { proxyFetch, type ProxyFetchOpts } from '@/lib/proxy';
import { assertOk } from './errors';
import { rateLimitForTransport, reportEhRateLimit, waitForEhRequest } from './request-control';
import type { SiteContext } from './urls';

export async function fetchEhText(
  url: string,
  site: SiteContext,
  opts: ProxyFetchOpts = {},
): Promise<string> {
  await waitForEhRequest(site.id, 'proxy', 0);
  try {
    const response = await proxyFetch(url, opts);
    return await assertOk(response, site.id);
  } catch (error) {
    if (!(error instanceof RateLimited)) throw error;
    const scopedError = rateLimitForTransport(error, 'proxy');
    reportEhRateLimit(site.id, 'proxy', scopedError);
    throw scopedError;
  }
}
